import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';
import { updateVars } from 'appSrc/redux/actions';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import { GoogleTagManager } from 'appSrc/components/Analytics/GoogleTagManager';
import { FACEBOOK_URI_REGEX } from 'appSrc/utils/video';
import axios from 'axios';
import style from './styles/style.module.css';


const MATCH_URL = FACEBOOK_URI_REGEX;
const PLAYER_ID_PREFIX = 'facebook-player-';

class FacebookPlayer extends Component {
    playerName = 'Facebook'

    constructor( props ) {
        super( props );

        this.id = PLAYER_ID_PREFIX + uuidv4();
        this.player = {};
        this.hasStarted = false;
        this.startTime = 0;
        this.videoTitle = '';
        this.verticalMode = false;
    }
    componentDidMount() {
        let clientEl = document.getElementById( this.id + '-wrapper' );
        let clientWidth = clientEl && clientEl.clientWidth;
        let alignerEL = document.getElementById( this.id + '-aligner' );

        axios( {
            url: 'https://noembed.com/embed',
            method: 'get',
            params: {
                url: this.props.url,
            },
        } )
        .then( ( response ) => {
            var data = response.data;

            this.videoTitle = data.title;
            this.author_name = data.author_name;
            this.author_url = data.author_url;
            this.author_id = data.author_id;
            this.media_id = data.media_id;
            this.provider_name = data.provider_name;
            this.provider_url = data.provider_url;
            this.videoHeight = data.height;
            this.videoWidth = data.width;
            this.verticalMode = data.height > data.width;
            if( this.verticalMode && clientEl && alignerEL ) {
                clientEl.style.paddingTop = '100%';
                // do a buncha math to figure out correct sizing ratios
                let ratio = clientWidth / data.height;
                ratio = data.width * ratio;
                ratio = ratio / clientWidth * 100;
                alignerEL.style.width = ratio + '%';
            }
        } )
        .then( () => {
            //wait for FB variable to be active
            var i = 0;
            var intervalID = window.setInterval( () => {
                if( window.FB && window.FB.XFBML ) {
                    window.clearInterval( intervalID );
                    this.activatePlayer();
                    this.props.dispatch( updateVars( { videoPlaying: this.id } ) );
                }else if( i > 99 ) {
                    window.clearInterval( intervalID );
                    console.warn( 'DL: Unable to load Facebook API' );
                }
                i++;
            }, 250 );
        } );
    }
    componentDidUpdate() {
        if( this.props.videoPlaying !== this.id ) {
            this.player && this.player.pauseVideo && this.player.pauseVideo();
        }
    }
    componentWillUnmount() {
        if( this.autoplayCheck ) {
            window.clearTimeout( this.autoplayCheck );
        }
    }
    activatePlayer = () => {
        FB.Event.subscribe( 'xfbml.render', () => {
            // Here we know the SDK has loaded, even if onReady/onPlay
            // is not called due to a video that cannot be embedded
            this.onLoaded();
        });
        FB.Event.subscribe( 'xfbml.ready', msg => {
            if ( msg.type === 'video' && msg.id === this.id ) {
                this.player = msg.instance;
                this.player.subscribe('startedPlaying', this.onPlay);
                this.player.subscribe('paused', this.onPause);
                this.player.subscribe('finishedPlaying', this.onEnded);
                this.player.subscribe('startedBuffering', this.onBuffer);
                this.player.subscribe('finishedBuffering', this.onBufferEnd);
                this.player.subscribe('error', this.onError);
                if( !this.props.muted ) {
                    // Player is muted by default
                    this.player.unmute();
                }
                this.onReady();

                // For some reason Facebook have added `visibility: hidden`
                // to the iframe when autoplay fails, so here we set it back
                document.getElementById( this.id ).querySelector('iframe').style.visibility = 'visible';
            }
        } );

        FB.XFBML.parse( document.getElementById( this.id + '-wrapper' ) );
    }
    onLoaded = () => {
        this.props.onLoaded( this.player );
    }
    onReady = () => {
        if( this.props.seekTo ) {
            this.player.seek( Math.ceil( this.props.seekTo / 1000 ) );
        }
        if( this.props.autoplay ) {
            // set a timeout to make sure the video is playing in .25 seconds
            this.autoplayCheck = window.setTimeout( () => {
                if( !this.hasStarted ) {
                    // autoplay failed, bubble the issue up
                    this.props.onError( {
                        type: 'autoplayerror',
                        error: 'Facebook Player has failed to autoplay',
                    } );
                }
                this.autoplayCheck = undefined;
            }, 1000 );
        }
        this.props.onReady( this.player );
    }
    onPlay = () => {
        // check to see if this is inital play
        if( this.hasStarted == false ) {
            this.hasStarted = true;
            if( this.props.autoplay ) {
                this.trackPlay( 'autoplay' );
            } else {
                this.trackPlay( 'started' );
            }
        } else {
            this.trackPlay( 'resumed' );
        }
        this.props.onPlay( this.player );
    }
    onPause = () => {
        this.trackPause( this.player.$VideoController_cache.$VideoCache_timePosition );
        this.props.onPause( this.player );
    }
    onBuffer = () => {
        this.props.onBuffer( this.player );
    }
    onBufferEnd = () => {
        this.props.onBufferEnd( this.player );
    }
    onEnded = () => {
        this.props.onEnded( this.player );
    }
    onError = ( e ) => {
        console.warn( 'Facebook Player Error: ', e );
        this.props.onError( e, this.player );
    }



    render() {
        return (
            <div id={ this.id + '-wrapper' }
            className={ style.videoPlayer }
            style={ this.props.style }>
                <div id={ this.id + '-aligner' } className={ style.aligner }>
                    <div className='fb-video'
                    id={ this.id }
                    style={ { height: '100%', width: '100%' } }
                    height={ this.videoHeight } width={ this.videoWidth }
                    data-href={ this.props.url }
                    data-autoplay={ this.props.autoplay ? 'true' : 'false' }
                    data-allowfullscreen='true'
                    data-controls={ this.props.controls ? 'true' : 'false' }
                    data-muted={ this.props.muted ? 'true' : 'false' } />
                </div>
            </div>
        );
    }


    trackPlay = ( type ) => {
        try {
            this.startTime = this.player.getCurrentPosition();
            let gEventName, mixEventName;
            switch ( type ) {
                case 'autoplay':
                    gEventName = 'Video Autoplay';
                    mixEventName = 'videoAutoplay';
                    break;
                case 'started':
                    gEventName = 'Video Started';
                    mixEventName = 'videoStarted';
                    break;
                default:
                    gEventName = 'Video Resumed';
                    mixEventName = 'videoResumed';
            }
            GoogleTagManager.track( gEventName, {
                video_provider: 'facebook',
                video_provider_link: this.props.videoId,
                video_title: this.videoTitle,
                attached_to: this.props.attachmentType,
                attached_id: this.props.attachmentId,
                video_author_id: this.props.authorId,
                start_time: this.startTime,
                resuming: this.hasPaused,
                ...this.props.metaData,
            } );
            Mixpanel.track( mixEventName, {
                video_provider: 'facebook',
                video_provider_link: this.props.videoId,
                video_title: this.videoTitle,
                attached_to: this.props.attachmentType,
                attached_id: this.props.attachmentId,
                video_author_id: this.props.authorId,
                start_time: this.startTime,
                resuming: this.hasPaused,
                ...this.props.metaData,
            } );
        } catch (e) {
            console.error( 'Analytics error', e );
        }
    }
    trackPause = ( time ) => {
        try {
            var pauseTime = time;
            GoogleTagManager.track( 'Video Paused', {
                video_provider: 'facebook',
                video_provider_id: this.props.videoId,
                video_title: this.videoTitle,
                attached_to: this.props.attachmentType,
                attached_id: this.props.attachmentId,
                video_author_id: this.props.authorId,
                start_time: this.startTime,
                pause_time: pauseTime,
                ...this.props.metaData,
            } );
            Mixpanel.track( 'videoPaused', {
                video_provider: 'facebook',
                video_provider_id: this.props.videoId,
                video_title: this.videoTitle,
                attached_to: this.props.attachmentType,
                attached_id: this.props.attachmentId,
                video_author_id: this.props.authorId,
                start_time: this.startTime,
                pause_time: pauseTime,
                ...this.props.metaData,
            } );
            this.startTime = pauseTime;
        } catch (e) {
            console.error( 'Analytics error', e );
        }
    }
}
FacebookPlayer.propTypes = {
    url: PropTypes.string.isRequired,
};
FacebookPlayer.defaultProps = {
    onLoaded: () => {},
    onReady: () => {},
    onPlay: () => {},
    onPause: () => {},
    onBuffer: () => {},
    onBufferEnd: () => {},
    onEnded: () => {},
    onError: () => {},
    muted: false,
};
FacebookPlayer.playerName = 'Facebook';
FacebookPlayer.canPlay = ( url ) => {
    return MATCH_URL.test( url );
};

const mapStateToProps = ( state ) => {
    return {
        videoPlaying: state.vars.videoPlaying,
    };
};

export default connect( mapStateToProps )( FacebookPlayer );
